import { blastApi } from '@features/flows/api/blast-api';
import type { SnapshotResponse } from '@features/flows/api/blast-api-types';

export async function fetchSnapshot(runId: string): Promise<SnapshotResponse> {
  return blastApi.getRunSnapshot(runId);
}

